const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
const DEFAULT_LOCAL_HOUR = 9;

export function normalizeScheduledAt(value?: string | Date | null): string | null {
  if (!value) return null;
  if (typeof value === 'string') {
    const match = DATE_ONLY.exec(value.trim());
    if (match) {
      const local = new Date(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3]),
        DEFAULT_LOCAL_HOUR,
        0,
        0,
        0,
      );
      return Number.isNaN(local.getTime()) ? null : local.toISOString();
    }
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
}
